
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import CalendarIcon from '@/components/icons/CalendarIconV2.vue';

@Component({
  components: {
    Datepicker,
    PlusIcon,
    CalendarIcon
  },
})
export default class FormDatepicker extends Vue {
  @Prop({ type: Date, default: undefined }) openDate?: Date;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "YYYY-MM-DD" }) readonly placeholder!: string;
  @Prop({ type: String, default: "" }) readonly calendarClass!: string;
  @Prop({ type: String, default: undefined }) readonly inputClass?: string;
  @Prop({ type: String, default: "" }) readonly iconStyle!: string;
  @Prop({ type: Array, default: () => [] }) readonly highlighted!: [];
  @Prop({ type: Object, default: () => { } }) readonly disabledDates!: object;
  @Prop({ type: String, default: "datePicker" }) readonly id?: string;
  @Prop({ type: String, default: "yyyy-MM-dd" }) format?: string;
  @Prop({ type:[Date, String], default: null }) value!: Date | string | null;
  @Prop({ type: String, default: "#717986" }) color?: string;
  @Prop({ type: Boolean, default: false }) readonly isCalenderIcon?: Boolean;

  @Prop({ type: Boolean, default: undefined })
  readonly customInputClass?: Boolean;

  $moment: any;

  highlightToday: Date = new Date();

  get classObject(): Object {
    return {
      "rounded-md": !this.customInputClass,
      "border-0 grayColor text-xs customInputBorder": this.customInputClass,
      "bg-input-disabled border-gray-200": this.disabled,
      "bg-inherit": !this.disabled,
      "w-full py-2.5 px-3 text-sm focus:outline-none focus:border-primary":
        !this.invalid,
      "w-full py-2.5 px-3 text-sm border border-red-300 placeholder-red-300 focus:border-red-300 text-red-800 outline-none":
        this.invalid,
      "customFormInput pl-3 pr-3 pb-2 pt-1.5": Boolean(this.inputClass),
    };
  }

  get highlightedDates(): Object {
    return {
      dates: [this.highlightToday, ...this.highlighted],
    };
  }

updateValue(date: any): void {
  if (date) {
    // Convert to ISO string and back to avoid timezone issues
   const localDate = this.$moment(date).format("YYYY-MM-DD");
    this.$emit("input", localDate);
  } else {
    this.$emit("input", date);
  }
}

}
